import React, {Component} from 'react';
import PropTypes from "prop-types"

import {browserHistory} from "react-router"
import Header from "../components/Header/Header"
import Footer from "../components/Footer/Footer"
import Sidebar from "../components/Sidebar/Sidebar"
import NavigationSidebar from "../components/Navigation/NavigationSidebar"
import CartMini from "../components/Cart/CartMini"
import app from "../app.controller"
import {Glyph, Button} from "elemental"
import {translate} from "translate"
import {Mindestbestellwert} from "../components/Cart/CartButton"
import shop from "shop/shop"
import "../util.scss"
const toCheckout = () => {
  browserHistory.push("/checkout")
}

class BaseLayout extends Component {
  render() {
    return (
      <div>
        <Sidebar
          right
          open={app.sidebar.open}
          toggle={app.sidebar.toggle}
          close={app.sidebar.close}>
          <section>
            <Button
              style={{width: "100%"}}
              onClick={app.sidebar.toggle.dispatch}
              type="primary"> <Glyph icon="triangle-left"/>{translate("shop.continue_shopping")}</Button> <br /></section>
          <CartMini />
          <section>
            <div className="pv3">
              <Mindestbestellwert sum={shop.cart.sum}/>
            </div>
            <Button
              style={{width: "100%"}}
              type="primary"
              onClick={() => {
                app.sidebar.close.dispatch()
                toCheckout()
              }}>{translate("shop.navigate_to_checkout")}<Glyph icon="triangle-right"/> </Button>
          </section>
        </Sidebar>
        <Sidebar
          left
          open={app.sidebarLeft.open}
          toggle={app.sidebarLeft.toggle}
          close={app.sidebarLeft.close}
        >
          <SidebarLeft/>
        </Sidebar>

        <div id="page-wrap"
             className="wrapper-wide ">
          <Header />
          <div id="page-container">
            {this.props.children}
          </div>
          <Footer />
        </div>
      </div>
    )
  }
}

BaseLayout.propTypes = {
  children: PropTypes.any
}


const SidebarLeft = () => {
  return (
    <div>
      <section>
        <Button
          style={{width: "100%"}}
          onClick={app.sidebarLeft.toggle.dispatch}
          type="primary"> <Glyph icon="triangle-right"/>Weiter Einkaufen</Button> <br /></section>
      <section>
        <NavigationSidebar/>
      </section>
    </div>
  )
}


export default BaseLayout



// WEBPACK FOOTER //
// ./src/layout/BaseLayout.js